export default __webpack_public_path__ + "694365c72d2b1046f4667964db55d402.png";